<template>
    <el-form :model="tableForm" ref="form" :rules="rules" class="formClass">
        <el-table stripe ref="multipleTable" :data="tableForm.tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="300">
            <!-- <el-table-column type="selection" width="55" /> -->
            <el-table-column show-overflow-tooltip prop="isRequired" width="60px">
                <template #default="{ row, $index }">
                    <el-form-item :prop="'tableData.' + $index + '.' + 'isRequired'">
                        <el-checkbox v-if="handleText !== 'detail'" :disabled="handleText !== 'add'"
                            v-model="row.isRequired" :true-label="1" :false-label="0">
                        </el-checkbox>
                        <span v-else :class="row.isRequired === 1 ? 'redName' : ''">
                        </span>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.name')" show-overflow-tooltip prop="name">
                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ row.name }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'name'" :rules="rules['name']">
                        <el-input type="text" v-model="row.name" style="width:100px" :placeholder="$t('integration.please_enter_a_name')"></el-input>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.code')" show-overflow-tooltip prop="code">

                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ row.code }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'code'" :rules="rules['code']">
                        <el-input type="text" v-model="row.code" style="width:100px" :placeholder="$t('integration.please_enter_the_code')"></el-input>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.data_type')" show-overflow-tooltip prop="dataType">
                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ dataTypeFn(row.dataType) }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'dataType'" :rules="rules['dataType']">
                        <el-select v-model="row.dataType" style="width:100px" @change="change(row.dataType, $index)">
                            <el-option v-for="item in dataType" :key="item.code" :value="item.code"
                                :label="$t('public.' + item.content)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.length')" show-overflow-tooltip prop="dataLength">
                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ row.dataLength }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'dataLength'"
                        :rules="row.dataType !== 4 ? row.rules || rules['dataLength'] : {}">
                        <el-input :disabled="row.disable" type="text" v-model="row.dataLength" style="width:100px"
                            :placeholder="$t('integration.please_enter_the_length')">
                        </el-input>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.rule')" show-overflow-tooltip prop="dataRule">
                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ ruleFn(row.dataRule) }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'dataRule'" :rules="rules['dataRule']">
                        <el-select v-model="row.dataRule" style="width:100px">
                            <el-option v-for="item in ruleArray" :key="item.code" :value="item.code" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('integration.explain')" show-overflow-tooltip prop="explain" width="150">
                <template #default="{ row, $index }">
                    <span v-if="handleText !== 'add'">
                        {{ row.explain }}
                    </span>
                    <el-form-item v-else :prop="'tableData.' + $index + '.' + 'explain'" :rules="rules['explain']">
                        <el-input type="text" v-model="row.explain" style="width:120px" :placeholder="$t('integration.please_enter_a_description')"></el-input>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="optare" width="80" v-if="handleText === 'add'">
                <template #default="{ row, $index }">
                    <el-form-item>
                        <i class="el-icon-plus" style="margin-right:10px" @click="handleAdd(row, $index)"></i>
                        <i class="el-icon-delete" @click="handleDel(row, $index)"></i>
                    </el-form-item>
                </template>
            </el-table-column>

        </el-table>
    </el-form>
</template>

<script>
import { ruleFn } from '../../validate/validate.js';
import { shareParam } from '@/api/modules/public.js';
export default {
    props: ['isMode', 'handleText', 'detailContent'],
    watch: {
        detailContent(newVal) {
            this.tableForm.tableData = { ...newVal }.deviceTypePropertyList
        }
    },
    computed: {
        rules() {
            return ruleFn.call(this, ['name', 'code', 'dataType', 'dataLength', 'dataRule', 'explain'])
        },
        inputRules() {
            let reg = /^\+?[1-9]\d*$/;
            const realNum = (rules, value, cb) => {
                // 小数
                const numArray = value.split(',');
                if (numArray.length !== 2) {
                    cb($t('integration.decimal_type_c__the_length_is_separated_by_a_comma_c__and_only_one_comma_is_allowed'))
                } else if (!reg.test(numArray[0]) || !reg.test(numArray[1])) {
                    cb($t('integration.only_positive_integers_are_allowed'))
                }
                cb()
            }
            const realNum2 = (rules, value, cb) => {
                if (!reg.test(value)) {
                    cb($t('integration.only_positive_integers_are_allowed'))
                }
                cb()
            }
            return {
                dataLength1: {
                    validator: realNum,
                    trigger: 'blur'
                },
                dataLength2: {
                    validator: realNum2,
                    trigger: 'blur'
                },
            }
        },
        baseRule() {
            return [{ required: true, message: $t('integration.length_cannot_be_empty'), trigger: 'blur' }]
        }
    },
    data() {
        return {
            tableForm: {
                tableData: [
                    {
                        name: '',
                        code: '',
                        dataType: '',
                        dataValue: '',
                        dataLength: '',
                        dataRule: '',
                        explain: '',
                        isRequired: 0
                    }
                ],
            },
            typeStatus: [],
            // 数据类型
            dataType: [],
            // 规则
            ruleArray: [],
            // 数据类型为时间时 禁止长度
            disable: false,
            dataTypeIndex: '',
        }
    },
    mounted() {

        this.initGetData();
    },
    methods: {
        initGetData() {
            this.getDataTypeFn();
            this.getRuleFn();
        },
        // 获取数据类型
        getDataTypeFn() {
            shareParam({ code: 'carrier_type_data_type', type: 0 }).then(({ result }) => {
                result.forEach(item => {
                    item.code = Number(item.code)
                })
                this.dataType = result;
            })
        },
        // 获取规则
        getRuleFn() {
            shareParam({ code: 'carrier_type_rule', type: 0 }).then(({ result }) => {
                result.forEach(item => {
                    item.code = Number(item.code)
                })
                this.ruleArray = result
            })
        },
        // 赋值dataValue
        change(id, index) {

            if (id === 3) {
                this.tableForm.tableData[index].rules = [this.inputRules['dataLength1']].concat(this.baseRule)
            } else {
                this.tableForm.tableData[index].rules = [this.inputRules['dataLength2']].concat(this.baseRule)
            }


            if (id === 4) {
                this.tableForm.tableData[index].disable = true;
                this.tableForm.tableData[index].dataLength = '20';
                this.$refs.form.clearValidate('tableData.' + index + '.' + 'dataLength')
            } else {
                this.tableForm.tableData[index].disable = false;
            }
            for (let item of this.dataType) {
                if (item.code === id) {
                    this.tableForm.tableData[index].dataValue = item.content;
                    break;
                }
            }
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.tableForm = {
                tableData: [
                    {
                        name: '',
                        code: '',
                        dataType: '',
                        dataValue: '',
                        dataLength: '',
                        dataRule: '',
                        explain: '',
                        isRequired: 0
                    }
                ],
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate()
            } catch (error) {
                return false
            }
        },
        handleAdd(row, index) {
            let query = {
                name: '',
                code: '',
                dataType: '',
                dataLength: '',
                dataRule: '',
                explain: '',
                isRequired: 0
            }
            this.tableForm.tableData.splice(index + 1, 0, query)
        },
        handleDel(row, index) {
            if (this.tableForm.tableData.length === 1) return this.$message.warning($t('integration.keep_at_least_one'));
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
            this.tableForm.tableData.splice(index, 1)
        },
        dataTypeFn(type) {
            let str;
            for (let item of this.dataType) {

                if (item.code === type) {
                    str = item.name;
                    break;
                }
            }
            return str
        },
        ruleFn(ruleId) {
            let str;
            for (let item of this.ruleArray) {

                if (item.code === ruleId) {
                    str = item.name;
                    break;
                }
            }
            return str
        }
    }
}
</script>

<style lang="scss" scoped>
.formClass {
    ::v-deep .el-form-item--mini.el-form-item {
        margin: 5px 0 15px 0;
    }

    i {
        cursor: pointer;

        &:hover {
            color: red;
            font-weight: bold;
        }
    }
}

.redName {
    &::before {
        content: '*';
        color: red;
        margin-right: 4px;
    }
}
</style>
